import { render, staticRenderFns } from "./BandlabConnection.vue?vue&type=template&id=7bb65c36&scoped=true&"
import script from "./BandlabConnection.vue?vue&type=script&lang=ts&"
export * from "./BandlabConnection.vue?vue&type=script&lang=ts&"
import style0 from "./BandlabConnection.vue?vue&type=style&index=0&id=7bb65c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb65c36",
  null
  
)

export default component.exports